import { Injectable } from '@angular/core';
import { DataService } from './data.service';

@Injectable({
  providedIn: 'root'
})
export class ResellerService {

  constructor(private dataService: DataService) { }

  saveReseller(reseller: any) {
    return this.dataService.post('/api/reseller/postReseller', reseller);
  };
  getResellerList(FilterSearch: string) {
    return this.dataService.getRecordWithParams('/api/reseller/getResellerDetailList', FilterSearch);
  };
  getResellerById(resellerId: number) {
    return this.dataService.getRecord('/api/reseller/getResellerDetailById/?resellerId=' + resellerId);
  };
  deleteResellerById(resellerId: number) {
    return this.dataService.getRecord('/api/reseller/deleteResellerDetailById/?resellerId=' + resellerId);
  };

  getRestrictEditbyResellerCode(resellercode: number) {
    return this.dataService.getRecord('/api/reseller/getRestrictEditbyResellerCode/?ResellerCode=' + resellercode);
  };

  IsResellerSalesDeleteAllowed(resellerSalesCode: number) {
    return this.dataService.getRecord('/api/reseller/IsResellerSalesDeleteAllowed/?ResellerSalesCode=' + resellerSalesCode);
  };

  addOrUpdateResellerSales(reseller: any) {
    return this.dataService.post('/api/reseller/addOrUpdateResellerSales', reseller);
  };

  getResellerSalesList(FilterSearch: string) {
    return this.dataService.getRecordWithParams('/api/reseller/getResellerSalesList', FilterSearch);
  };

  getResellerSalesById(resellerSalesId: number) {
    return this.dataService.getRecord('/api/reseller/getResellerSalesById/?resellerSalesId=' + resellerSalesId);
  };

  deleteResellerSalesById(resellerSalesId: number) {
    return this.dataService.getRecord('/api/reseller/deleteResellerSalesById/?resellerSalesId=' + resellerSalesId);
  };

  generateManageResellerSalesReport() {
    return this.dataService.getRecord('/api/reseller/exportResellerSalesAsExcel');
  };

}
